import React from "react"
import { Text, Flex } from "@chakra-ui/react"
import ResolvedImage from "@app/components/ResolvedImage"

type Props = {
  content: {
    _key: string
    icon: GatsbyTypes.SanityImage
    text: string
  }[]
}

const ProductTabInfo: React.FC<Props> = ({ content }) => {
  return (
    <Flex gap="16px" p="32px" flexDir={{ base: "column", lg: "row" }}>
      {content &&
        content.map(item => (
          <Flex key={item._key} gap="16px" flex={1}>
            <ResolvedImage image={item.icon} w={{ base: "24px", lg: "40px" }} h={{ base: "24px", lg: "40px" }} />
            <Text mt="2px" lineHeight={1.5}>
              {item.text}
            </Text>
          </Flex>
        ))}
    </Flex>
  )
}

export default React.memo(ProductTabInfo)
